import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../../app.constants';
import { LoaderService } from '../../../services/loader.service';
import { UserManagementService } from '../../../services/user-management.service';
import { ContentState } from '../../../store/state/content.state';
import { IframeComponent } from '../iframe/iframe.component';

@Component({
    selector: 'u4-cpp-track-cases',
    templateUrl: './track-cases.component.html',
    styles: []
})
export class TrackCasesComponent extends IframeComponent implements OnInit {

    public downloadUrl: string;
    public downloadInitialized: boolean;
    public hasSupportPermissions$: Observable<boolean>;
    public hasUserManagementPermissions$: Observable<boolean>;
    public labels: {[key: string]: string};

    constructor(
        protected loaderService: LoaderService,
        protected route: ActivatedRoute,
        protected sanitizer: DomSanitizer,
        protected store: Store<ContentState>,
        private userManagementService: UserManagementService
    ) {
        super(loaderService, route, sanitizer, store);
        this.downloadUrl = SERVER_API_URL + 'api/support/cases/download';
    }

    ngOnInit() {
        this.hasSupportPermissions$ = this.userManagementService.hasPermission('SUPPORT');
        this.hasUserManagementPermissions$ = this.userManagementService.hasPermission('USERMANAGEMENT');
        super.ngOnInit();
    }

    onClick(event: Event) {
        if (this.downloadInitialized) {
            event.preventDefault();
        }
        this.downloadInitialized = true;
    }

}
